<template>
   <div class="page">
     <div class="swps">
       <van-swipe class="my-swipe" :autoplay="5000" indicator-color="white">
          <van-swipe-item>
            <div class="li fst-li">
              <div class="containt-div">
                  <div class="baner-01-a">
                    <div class="caption">
                      <div class="tit">闲逸麻将</div>
                      <div class="txt"><span>闲情逸致   乐在其中!</span></div>
                      <div class="tags"><span>安全稳定</span><span>无外挂</span><span>无黑幕</span></div>
                    </div>
                  </div>
                  <div class="baner-01-b" @click="toGames(5)">査看详情 ></div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div class="li sec-li">
              <div class="containt-div">
                  <div class="baner-01-a">
                    <div class="caption">
                      <div class="tit">碰胡专场</div>
                      <div class="txt"><span>好玩又有趣的碰胡，等你来玩哟!</span></div>
                      <div class="tags"><span>安全稳定</span><span>无外挂</span><span>无黑幕</span></div>
                    </div>
                  </div>
                  <div class="baner-01-b" @click="toGames(2)">査看详情 ></div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
     </div>

     <div class="page-content">
       <div class="index-games">
         <div class="li" v-for="(item,index) in games" :key="index"><img @click="toGames(item.type)" :src="item.src" alt=""></div>
       </div>

       <div class="index-news">
          <div class="news-title">
              <img src="@/assets/images/news-title.png">
              <div class="more" @click="toActivity()">更多</div>
          </div>

          <div class="news-lists">
            <ul>
              <li @click="toNews(item.type)" v-for="(item,index) in lists" :key="index"><p><i class="icon-tips1"></i>{{item.name}}</p><span>{{item.time}}</span></li>
            </ul>
          </div>
      </div>

     </div>

     
   </div>
</template>
<script>
import Vue from 'vue'

export default {
  components: {
    pageFooter: () => import('@/components/footer')
  },
  data () {
    return {
     games : [
       {
         src : require('@/assets/images/ddz-icon.png'),
         type : 1
       },
       {
         src : require('@/assets/images/ph-icon.png'),
         type : 2
       },
       {
         src : require('@/assets/images/hz-icon.png'),
         type : 3
       },
       {
         src : require('@/assets/images/zz-icon.png'),
         type : 4
       }
     ],
     lists : [
       {
         name : '【六胡抢，湖南麻将，岳阳棋牌老版本迁移公告】',
         time : '2017/12/07',
         type : 1
       }
     ]
    }
  },
  created () {
  },
  mounted () {
  },
  
  methods: {
    toNews(e){
      let path = `/activityDetail?type=${e}`
      this.$router.push({
          path
      })
    },
    toGames(e){
      let path = `/gameDetail?type=${e}`
      this.$router.push({
          path
      })
    },
    toActivity(){
      let path = `/activity`
      this.$router.push({
          path
      })
    }
  }
}
</script>
<style lang="less" scoped>
.swps{
  width: 100%;
  .my-swipe .van-swipe-item {
      color: #fff;
      font-size: 10px;
  }
  .li{
    width: 100%;
    height: 300px;
  }
  .fst-li{
    background: url(../../assets/images/barnner-1.jpg) center no-repeat;
    background-size: cover;
  }
  .sec-li{
    background: url(../../assets/images/barnner-4.jpg) center no-repeat;
    background-size: cover;
  }
  .containt-div{
      max-width: 512px;
      position: relative;
      height: 300px;
      margin: 0 auto;
      padding-left: 10px;
      box-sizing: border-box;
  }

  .baner-01-a{
    padding-top: 140px;
    .tit{
      margin-bottom: 10px;
    }
    .txt{
      margin-bottom: 10px;
      span{
        padding-bottom: 4px;
        border-bottom: 1px solid #fff;
      }
    }
    .tags{
      span{
        margin-right: 10px;
      }
      margin-bottom: 40px;
    }
  }
  .baner-01-b{
    width: 110px;
    height: 26px;
    background: #fff;
    border-radius: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #b42ce3;
  }

  
}

.page-content{
	width: 100%;
	clear: all;
	overflow: hidden;
	background-image: url(../../assets/images/girl.png),url(../../assets/images/d-bg.png);
	background-position: left top, right bottom;
	background-repeat: no-repeat, no-repeat;
  padding: 20px 0;

  .index-games{
    max-width: 512px;
    position: relative;
    height: 80px;
    margin: 0 auto;
    display: flex;
    .li{
      flex: 1;
      height: 73px;
      display: flex;
      justify-content: center;
      
      img{
        width: 73px;
        height: 73px;
        cursor: pointer;
      }
    }
  }

  .index-news{
    max-width: 512px;
    position: relative;
    margin: 0 auto;
    background: #fff;
    margin-top: 30px;
  }
  .news-title{
    display: flex;
    align-items: center;
    padding: 10px 0 0 10px;
    box-sizing: border-box;
    img{
      width: 122px;
      height: auto;
    }
    .more{
      border: 1px solid #57bdf4;
      color: #57bdf4;
      width: 54px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 10px;
      border-radius: 24px;
      cursor: pointer;
      font-size: 10px;
    }
  }
  .news-lists{
    border-top: 1px solid #ccc;
    margin-top: 10px;
    li{
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #ccc;
      padding: 0 10px;
      box-sizing: border-box;
      cursor: pointer;
      p{
        display: flex;
        height: 100%;
        align-items: center;
      }
      i{
        display: block;
        width: 38px;
        height:35px;
      }
      .icon-tips1{
        background: url(../../assets/images/tip-blue.png) center center no-repeat;
      }
      .icon-tips2{
        background: url(../../assets/images/tip-grey.png) center center no-repeat;
      }
    }
  }
}

@media (max-width:800px) {
  .swps{
    .my-swipe .van-swipe-item {
        font-size: 14px;
    }
    .li{
      height: 250px;
    }
    .containt-div{
        height: 250px;
    }

    .baner-01-a{
      padding-top: 40px;
      
      .tags{
        margin-bottom: 20px;
      }
    }
  }

  .page-content{

    .index-games{
      height: auto;
      flex-wrap: wrap;
      .li{
        flex: none;
        width: 50%;
        height: 100px;
        margin-bottom: 20px;
        img{
          width: 100px;
          height: 100px;
        }
      }
    }

    .index-news{
      margin-top: 10px;
    }


  .news-lists{
    li{
      i{
        width: 20px;
        height:18px;
      }
    }
  }
}

}



</style>
